<template>
  <div class="import-jobs">
    <el-button
      size="small"
      style="width: 100%; margin-bottom: 2px"
      @click="openDialog()"
    >
      Настроить доступ к <strong>документации</strong>
    </el-button>

    <el-dialog :title="`Настройка доступа к документации`" :visible.sync="dialogObject">
      <div class="add-jobs" v-show="!objectId" v-if="dialogObject">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div style="margin-top: 20px; margin-bottom: 10px; display: flex">
          <el-switch
            v-model="usePermission"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          <strong style="margin-left: 10px">Выкл/Вкл настройки доступов</strong>
        </div>
        <el-table
          row-key="id"
          @select="handleSelectionChangeObject"
          @select-all="handleSelectionChangeObject"
          empty-text="Разделы не найдены"
          ref="multipleObjectTable"
          :data="filteredList"
          style="width: 100%"
        >
          <el-table-column
            v-if="usePermission"
            property="check"
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column
            property="name"
            label="Разделы"
          >
          </el-table-column>
          <el-table-column
            width="50px"
          >
            <template slot-scope="scope">
              <i class="fa fa-edit" @click="selectObject(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
        <!--        <div class="jobs-ul">-->
        <!--          <div-->
        <!--            @click="selectObject(list)"-->
        <!--            class="jobs-li" v-for="(list, index) in filteredList" :key="index"-->
        <!--          >-->
        <!--            <span>{{ list.name }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="add-jobs" v-show="objectId" v-loading="loading">
        <el-input placeholder="Поиск ..." v-model="jobSearch" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">

          <el-table
            @selection-change="handleSelectionChangeJob"
            empty-text="Файлы не найдены"
            ref="jobsTable"
            :data="filteredJobs"
            style="width: 100%"
          >
            <el-table-column
              v-if="usePermission"
              property="check"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              property="name"
              label="Файлы"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="create-footer">
        <el-button @click="back" v-if="objectId">Назад</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {getChildList} from '../../../utils/getChild';

export default {
  name: 'PermissionDocs',
  props: ['name', 'user', 'id'],
  data() {
    return {
      search: '',
      jobSearch: '',
      dialogObject: false,
      objectId: null,
      selectedObjects: [],
      selectedJob: [],
      loading: false,
      availableFiles: {},
      availableObjectsDocs: [],
      usePermission: false,
      list: [],
      jobs: [],
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredJobs() {
      return this.jobs.filter(object => {
        return object.name.toLowerCase().includes(this.jobSearch.toLowerCase());
      });
    },
  },

  watch: {
    filteredList: _.debounce(function () {
      this.filteredList.map((row) => {
        const availableObjectsDocs = this.availableObjectsDocs.map((a) => a.id);
        if (availableObjectsDocs.includes(row.id) || (this.user.available_docs && this.user.available_docs.includes(row.id))) {
          this.$refs.multipleObjectTable.toggleRowSelection(row);
        }
      })
    }, 200),
    filteredJobs: _.debounce(function () {
      this.filteredJobs.map((row) => {

        const availableFiles1 = this.availableFiles[this.objectId].map((a) => a.id);

        if (availableFiles1.includes(row.id)
          || (this.user.available_files && this.user.available_files[this.objectId]
            && this.user.available_files[this.objectId].includes(row.id))
        ) {
          this.$refs.jobsTable.toggleRowSelection(row);
        }
      })
    }, 200)
  },

  mounted() {
    this.fetchTree();
  },

  methods: {
    selectObject({id}) {
      this.objectId = id;
      this.fetchJobs();
    },
    back() {
      this.objectId = null;
    },
    openDialog() {
      this.dialogObject = true;
      setTimeout(() => {
        this.usePermission = this.user.usePermissionDocs;

        // this.availableFiles = this.user.available_files;
        this.list.map((row) => {
          if (this.user.available_docs && this.user.available_docs.includes(row.id)) {
            this.$refs.multipleObjectTable.toggleRowSelection(row);
            this.availableObjectsDocs.push(row);
          }
        })
      }, 100);
    },
    fetchJobs() {
      // this.availableFiles = this.user.available_files;

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('files')
        .where(`documentation`, 'array-contains-any', [this.objectId]).get()
        .then((data) => {
          const result = [];
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              _data: data,
              index: data.index
            });
          });

          this.jobs = _.orderBy(result, 'index', ['asc']);
          const available_files =  this.user.available_files[this.objectId] && this.user.available_files[this.objectId];

          setTimeout(() => {
            this.availableFiles[this.objectId] = [];
            this.jobs.map((row) => {
              if (this.user.available_files && available_files.includes(row.id)) {
                this.availableFiles[this.objectId].push(row)
              }
            })
          }, 100);
        });
    },
    handleSelectionChangeObject(selected) {
      this.selectedObjects = selected;
      this.availableObjectsDocs = this.list.filter((s) => {
        return this.selectedObjects.find((l) => l.id === s.id)
      });
    },
    handleSelectionChangeJob(selected) {
      this.selectedJob = selected;

      const available = [];
      if (Array.isArray(this.availableFiles)) {
        this.availableFiles = {};
      }

      this.availableFiles[this.objectId].map((d) => {
        if (this.selectedJob.find((s) => d.id === s.id)) {
          available.push(d);
        }
      })

      this.availableFiles[this.objectId] = [...available, ...this.jobs.filter((s) => {
        return this.selectedJob.find((l) => l.id === s.id);
      })];
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('documentation')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = [
          {
            id: 'all',
            name: 'Корневой каталог',
            index: 0,
            isParent: true,
          },
          ..._.orderBy(getChildList(result), 'index', ['asc']),
        ];
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    async save() {
      this.loading = true;
      const availableFiles = {}
      const users_jobs = this.user.available_files;

      Object.entries(this.availableFiles).forEach(([key, value]) => {
        availableFiles[key] = _.uniq(value.map((o) => o.id))
      })

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.id)
        .update({
          ...this.user,
          usePermissionDocs: this.usePermission,
          available_files: {...users_jobs, ...availableFiles},
          available_docs: _.uniq(this.availableObjectsDocs.map((o) => o.id))
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно',
          message: 'Доступ пользователя изменен',
          type: 'success',
        });
      }).catch((error) => {
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
      //
      // batch.commit().then((response) => {
      // this.loading = false;
      // this.$notify({
      //   offset: 60,
      //   title: 'Успешно!',
      //   message: 'Доступы изменены',
      //   type: 'success',
      // });
      this.$emit('update', {
        ...this.user,
        usePermissionDocs: this.usePermission,
        available_files: {...users_jobs, ...availableFiles},
        available_docs: _.uniq(this.availableObjectsDocs.map((o) => o.id))
      });
      if (this.objectId) {
        return this.objectId = null;
      } else {
        this.close();
      }
      // });
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.objectId = null;
      this.selectedJob = [];
      this.selectedObjects = [];
      this.search = '';
    },
  },
};
</script>

<style scoped lang="scss">

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.jobs-core {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/PermissionDocs.vue